// extracted by mini-css-extract-plugin
export var tooltip = "styles-module__tooltip___PlkqZ";